import React from 'react';
import cn from 'clsx';
import { ChevronRightIcon } from '@fronton/icons-react';
import { Typography } from '../../typography';
import {
  moreInfoCardNameIcon,
  moreInfoCardNameIconWrapper,
  moreInfoCardNameWrapper,
  moreInfoCardText
} from './more-info-card-styles';

type MoreInfoCardBodyProps = {
  className?: string;
  title: string;
  wrapText?: boolean;
};

export const MoreInfoCardBody: React.FC<MoreInfoCardBodyProps> = ({ className, title, wrapText }) => (
  <div className={cn(className, moreInfoCardNameWrapper)}>
    <Typography className={cn({ [moreInfoCardText]: wrapText })} adaptive={false} variant="h3">
      {title}
    </Typography>
    <div className={cn({ [moreInfoCardNameIconWrapper]: wrapText })}>
      <ChevronRightIcon bold className={moreInfoCardNameIcon} color="text-primary" size="m" type="outline" />
    </div>
  </div>
);
